import { doPost } from './common'

/*

*/

export const start = (breakId, stepId, listicleId) => {

    let payload = {
        breakId: breakId,
        stepId: stepId,
        listicleId: listicleId
    }

    return doPost(`/listicle/start`, payload);

}

export const complete = (breakId, stepId, stepSkipped) => {

    let payload = {
        breakId: breakId,
        stepId: stepId,
        skipped: stepSkipped
    }

    return doPost(`/listicle/complete`, payload);

}

export const vote = (listicleId, itemId, voteType) => {

    let payload = {
        'listicleId': listicleId,
        'itemId': itemId,
        'vote': voteType,
    }

    return doPost(`/listicle/vote`, payload);

}
